import React, {Fragment, useEffect} from 'react';
import Navbar from "./Navbar";
import {Outlet, useLocation} from "react-router-dom";
import {useInitAuthenticatedUser} from "../hooks/useInitAuthenticatedUser";
import {ToastContainer} from "react-toastify";
import Footer from "./Footer";
import {trackPageView} from "../utils/fbPixel";
import CartDrawer from "./CartDrawer";
import CookieConsentBanner from "./CookieConsentBanner";
import {syncShopFeatureFlagFromUrl, syncPayByBankFeatureFlagFromUrl, syncMollieFeatureFlagFromUrl} from "../utility/featureFlags";

const Layout = () => {
    useInitAuthenticatedUser();
    const location = useLocation();

    // Track PageView on route change (only in production)
    useEffect(() => {
        trackPageView();
    }, [location]);

    // Pick up ?shop=1/0, ?paybybank=1/0 and ?mollie=1/0 on any page and persist them for the session
    useEffect(() => {
        syncShopFeatureFlagFromUrl(location.search);
            syncPayByBankFeatureFlagFromUrl(location.search);
        syncMollieFeatureFlagFromUrl(location.search);
    }, [location]);

    return (
        <Fragment>
            <Navbar/>
            <main className="container mx-auto px-4 py-6 mt-16 md:mt-20">
                <Outlet/>
            </main>
            <Footer/>
            <ToastContainer/>
            <CartDrawer/>
            <CookieConsentBanner/>
        </Fragment>
    );
};

export default Layout;
